'use client'

import Image from 'next/image'
import { useState } from 'react'

type Props = {
  name: string
  image?: string
  initials?: string
}

export default function ReferenceAvatar({ name, image, initials }: Props) {
  const [failed, setFailed] = useState(false)

  return (
    <div className="size-12 shrink-0 border-2 border-[#00E59E] bg-white p-0.5">
      <div className="h-full w-full overflow-hidden bg-white">
        {image && !failed ? (
          <Image
            src={image}
            alt={name}
            width={48}
            height={48}
            className="w-full h-full object-cover"
            onError={() => setFailed(true)}
          />
        ) : (
          <div
            className="flex h-full w-full items-center justify-center bg-[#DFFFF3] font-semibold text-[#1A1D3E]"
            aria-label={name}
          >
            {initials}
          </div>
        )}
      </div>
    </div>
  )
}
